/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboCalculationGroupModifierRequestSchema } from "./comboCalculationGroupModifierRequestSchema.ts";
import { comboCalculationModifierRequestSchema } from "./comboCalculationModifierRequestSchema.ts";

export const comboCalculationItemRequestSchema = z.object({
	id: z.uuid(),
	amount: z.int().min(1),
	size: z.uuid().nullish(),
	modifiers: z.array(comboCalculationModifierRequestSchema).nullish(),
	group_modifiers: z.array(comboCalculationGroupModifierRequestSchema).nullish(),
});
